import Vue from 'vue'
import VueRouter from 'vue-router'
import ShowsList from '@/comp/ShowsList'
import Show from '@/comp/Show'

Vue.use(VueRouter)

let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: ShowsList,
            
        },
        {
                    path: '/detail/:id',
                    name: 'detail',
                    component: Show,
                    meta: {
                        linkText: "Latest"
                    }
                }

    ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js